import {
  radioSchema,
  radioUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../locales/en/content.json';

const TITLE_TEXT = content['supplemental--ohi-title'];
const INPUT_LABEL = content['supplemental--ohi-label'];

const SCHEMA_LABELS = {
  docs: content['supplemental--ohi-option--docs'],
  insurance: content['supplemental--ohi-option--insurance'],
  both: content['supplemental--ohi-option--both'],
};

const SCHEMA_DESCRIPTIONS = {
  docs: content['supplemental--ohi-option--docs-description'],
  insurance: content['supplemental--ohi-option--insurance-description'],
  both: content['supplemental--ohi-option--both-description'],
};

const SCHEMA_ENUM = Object.keys(SCHEMA_LABELS);

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT),
    'view:ohiToUpdate': radioUI({
      title: INPUT_LABEL,
      labels: SCHEMA_LABELS,
      descriptions: SCHEMA_DESCRIPTIONS,
      tile: true,
    }),
  },
  schema: {
    type: 'object',
    required: ['view:ohiToUpdate'],
    properties: {
      'view:ohiToUpdate': radioSchema(SCHEMA_ENUM),
    },
  },
};
